import React from "react";
// import MiCompAPI from "./../../util/api";
import {
  Form,
  Row,
  Col,
  Layout,
  Select,
  Icon,message
} from "antd";
import MiCompAPI from "../../../util/api";
const { Content } = Layout;
const { Option } = Select;
class MI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      carriers: [],
      filedata: null,
      lob: [],
      plan:[],
      loa:[],
      plans:"",
      mems:[],
      planProp:"",
      propData:[]
    };
     this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentDidMount = () => {
    this.GetLoAofUser();  
  }
 
  GetLoAofUser() {
    this.api.invoke("GetLoAofUser", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
           this.setState({
            lob: data.data,
          });

          this.setState({ allLoALoading: false });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }


  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler({ ...values });
      }
    });
  }
  GetCarrierByLoA = (id) => {
    this.api.invoke(
      "GetCarrierByLoA/" +id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({             
              carriers: data.data,
            loa:id,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
    );
  };
  onChange = (e) => {  
 
    this.GetCarrierByLoA(e);
  }
  GetPlanByCarrier = (client_id,loa) => {

    this.api.invoke(
      "GetPlanByCarrier/" + client_id + "/" + loa,
      "get",
      (data, success) => {
        
        if (success) {
          if (data.statusCode === 200) {
            this.setState({             
              plan: data.data,
            
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
    );
  };
  
  onCarrierChanges = (e) => {     
    this.GetPlanByCarrier(e,this.state.loa);
  }
  onPlanChanges = (e) => {    
    const a=e.split('_')[1]; 
    
    
    this.setState({             
      planProp: e.split('_')[1],    
    });
    this.props.submitHandler(a);
    
  }
  
  
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="mi_main" style={{padding:"0px"}}>
        <Content>
          <div style={{background:'white',padding: '25px 5px',borderRadius:'6px'}}>
          {/* <Card type="inner"> */}
          <Row>
            <Form
              onSubmit={this.handleSubmit}
              layout="vertical"
              hideRequiredMark
            >
              <Row span={24}>

                <Col md={8} sm={24}>
                  <Form.Item>
                  <fieldset className="mi_input_pop" style={{ marginRight: '2px' }}>
                <legend className="legend-font">LOA</legend>
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: 'Please select loa' },
                  ],
                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                  optionFilterProp="children"
                  showSearch={true}
                  onChange={this.onChange}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Please Select loa">
                  {this.state.lob ? this.state.lob.map(tag => <Option value={tag.name} key={tag.id}>{tag.name}</Option>) : ""}
                </Select>
                )}
              </fieldset>
                  </Form.Item>
                </Col>
                <Col md={8} sm={24}>
                  <Form.Item>
                  <fieldset className="mi_input_pop" style={{ marginRight: '2px' }}>
                <legend className="legend-font">Carrier</legend>
                {getFieldDecorator('carrier', {
                  rules: [{ required: true, message: 'Please select Carrier' },
                  ],
                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                  optionFilterProp="children"
                  showSearch={true}
                  onChange={this.onCarrierChanges}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Please Select Carrier">
                  {this.state.carriers ? this.state.carriers.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>) : ""}
                </Select>
                )}
              </fieldset>
                  </Form.Item>
                </Col>
                <Col md={8} sm={24}>
                  <Form.Item>
                  <fieldset className="mi_input_pop" style={{ marginRight: '2px' }}>
                <legend className="legend-font">Plan</legend>
                {getFieldDecorator('plan', {
                  rules: [{ required: true, message: 'Please select Plan' },
                  ],
                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                  optionFilterProp="children"
                  showSearch={true}
                  onChange={this.onPlanChanges}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Please Select plan">
                  {this.state.plan ? this.state.plan.map(tag => <Option value={tag.name} key={tag.id}>{tag.name}</Option>) : ""}
                </Select>
                )}
              </fieldset>
                  </Form.Item>
                </Col>

              </Row>

              
            </Form>
          </Row>
          {/* </Card> */}</div>
        </Content>
      </div>
    )
  }
}

const SearchMemberForm = Form.create()(MI);
export default SearchMemberForm;